<div class="radio-group-wrapper">
    <mat-radio-group (change)="changeValue($event)" class="{{panelClass}}">
        <mat-radio-button
            class="pr-2"

            disableRipple

            *ngFor="let option of asFormsControl().options"

            [value]="option.value"
            [color]="option.color"
            [checked]="option.checked"
            [disabled]="option.disabled"
        >
            {{option.label}}
        </mat-radio-button>
    </mat-radio-group>
    <div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
        <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
    </div>
</div>
